<ion-content class="md-page md-padded ly-col" *mobxAutorun>
  <analytics-header class="ion-padding-vertical" (ionChangeFilters)="filtersChanged($event)">
  </analytics-header>

  <performance-grid
    [analyze]="true"
    [view]="filterBy"
    [showHeader]="false"
    [compact]="true"
    [showPeriod]="false"
    [startDate]="start"
    [endDate]="end"
    [period]="undefined"
    [startDateCompare]="compareResults ? startCompare : undefined"
    [endDateCompare]="compareResults ? endCompare : undefined"
    [accountService]="socials"
    class="ion-padding-vertical"
  >
  </performance-grid>

  <ion-row class="ion-padding-vertical">
    <leaderboard-list class="flex" [showFullButton]="false" [startDate]="start" [endDate]="end">
    </leaderboard-list>
    <netsocial-insights class="flex ion-margin-start"> </netsocial-insights>
  </ion-row>

  <ion-row class="ion-padding-vertical">
    <performance-chart
      [startDate]="start"
      [endDate]="end"
      [showLink]="false"
      [accountService]="socials"
      [selectedView]="filterBy"
      class="ion-margin-end"
    >
    </performance-chart>
  </ion-row>

  <ion-row class="ion-margin-top ion-align-items-center">
    <ns-button-group [value]="exportOption" (ionChange)="exportOption = $event">
      <ns-button-item [value]="value" *ngFor="let value of ['excel', 'csv', 'email']">
        <span
          [class.ion-text-uppercase]="value === 'csv'"
          [class.ion-text-capitalize]="value === 'excel' || value === 'email'"
        >
          {{value}}
        </span>
      </ns-button-item>
    </ns-button-group>
    <ion-button
      class="ion-margin-start quick-export"
      (click)="quickExport()"
      [promiseBtn]="exportPromise"
    >
      {{"quickExportText" | translate}}
    </ion-button>
  </ion-row>

  <page-title
    icon="list"
    [title]="'workspace.dashboard.titles.' + (isAdmin ? 'topPosts' : 'companyTopPosts')"
    class="ion-margin-vertical ion-padding-vertical"
  >
  </page-title>

  <post-list
    type="top-post"
    [disabledOverflow]="true"
    [hideGrouping]="true"
    [startDate]="start"
    [endDate]="end"
    [accountService]="socials"
    [period]="undefined"
    [scope]="'team'"
  >
  </post-list>
</ion-content>
